"use client";

import { useEffect } from "react";
import { FlatNamespace, KeyPrefix } from "i18next";
import i18next from "./i18next";
import {
  useTranslation,
  UseTranslationOptions,
  UseTranslationResponse,
  FallbackNs,
} from "react-i18next";
import { headerName, cookieName } from "./settings";

// const runsOnServerSide = typeof window === "undefined";

type $Tuple<T> = readonly [T?, ...T[]];

export function useT<
  Ns extends FlatNamespace | $Tuple<FlatNamespace>,
  KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined,
>(
  ns?: Ns,
  options?: UseTranslationOptions<KPrefix>
): UseTranslationResponse<FallbackNs<Ns>, KPrefix> {
  // source code from react-i18next
  // const lng = useParams()?.lng;
  // if (typeof lng !== "string")
  //   throw new Error("useT is only available inside /app/[lng]");
  // if (runsOnServerSide && i18next.resolvedLanguage !== lng) {
  //   i18next.changeLanguage(lng);
  // } else {
  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   const [activeLng, setActiveLng] = useState(i18next.resolvedLanguage);
  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   useEffect(() => {
  //     if (activeLng === i18next.resolvedLanguage) return;
  //     setActiveLng(i18next.resolvedLanguage);
  //   }, [activeLng, i18next.resolvedLanguage]);
  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   useEffect(() => {
  //     if (!lng || i18next.resolvedLanguage === lng) return;
  //     i18next.changeLanguage(lng);
  //   }, [lng, i18next]);

  useEffect(() => {
    // Seulement si i18next n'a pas encore de langue définie
    if (!i18next.resolvedLanguage) {
      // 1. Header du middleware (priorité maximale)
      const headerValue = document
        .querySelector(`meta[name="${headerName}"]`)
        ?.getAttribute("content");

      if (headerValue) {
        i18next.changeLanguage(headerValue);

        // localStorage.setItem("i18nextLng", headerValue as Lang);
        i18next.services.languageDetector.detectors = [];
        return;
      }

      // 2. Cookie (fallback)
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${cookieName}=`))
        ?.split("=")[1];

      if (cookieValue) {
        i18next.changeLanguage(cookieValue);
        //localStorage.setItem("i18nextLng", cookieValue as Lang);
        return;
      }

      // 3. Navigateur (dernier recours)
      // const browserLang = navigator.language.split("-")[0];
      // const supportedLang = languages.includes(browserLang as Lang)
      //   ? browserLang
      //   : fallbackLng;
      // i18next.changeLanguage(supportedLang);
    }
  }, []);

  return useTranslation(ns, options);
}
